'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./NoAudio.scss');

var NoAudio = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(NoAudio, _PureComponent);

  function NoAudio() {
    (0, _classCallCheck3.default)(this, NoAudio);
    return (0, _possibleConstructorReturn3.default)(this, (NoAudio.__proto__ || (0, _getPrototypeOf2.default)(NoAudio)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoAudio, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.container) },
        _react2.default.createElement('p', { className: styles.icon }),
        _react2.default.createElement(
          'p',
          null,
          t('There are no audio files in this playlist')
        )
      );
    }
  }]);
  return NoAudio;
}(_react.PureComponent), _class2.propTypes = {
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = NoAudio;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/components/NoAudio.js
// module id = 2169
// module chunks = 1